import { ApolloError, QueryResult, useQuery } from '@apollo/client';
import GET_FEELINGS_MATCH_ACTIVITY from '../../queries/activities/feelings-match-query';
import { FeelingsMatchActivity as FeelingsMatch } from '@monorepo/shared/src/graph/schema-generated-types-student';
import { StoreTypename } from 'types';

const DEFAULT_BOOK_EDTION = 2022;

export type FeelingsMatchActivityState = {
  activity: any;
  error: ApolloError | undefined;
  isLoading: boolean;
};
export type FeelingsMatchActivityDispatch = undefined;
export type FeelingsMatchActivity = [FeelingsMatchActivityState, FeelingsMatchActivityDispatch];

export const FeelingsMatchActivity = (): { __typename: string } => ({
  __typename: StoreTypename.FEELINGS_MATCH_ACTIVITY,
});

const useFeelingsMatchActivityStore = (
  bookCode: string,
  edition?: number
): FeelingsMatchActivity => {
  const { data, loading, error }: QueryResult<{ feelingsMatch: FeelingsMatch | undefined }> =
    useQuery(GET_FEELINGS_MATCH_ACTIVITY, {
      variables: { where: { book: { bookCode, edition: edition || DEFAULT_BOOK_EDTION } } },
    });

  return [
    {
      activity: data?.feelingsMatch || null,
      error,
      isLoading: loading,
    },
    undefined,
  ];
};

export default useFeelingsMatchActivityStore;
